import React from "react";
import { ArrowRight, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeaturedOffering() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21582" id="hero-calltoaction" ref={ref} className={`bg-gradient-to-b from-slate-50 to-slate-200 text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:gap-16 items-stretch">
          {}
          <div className="relative h-[400px] lg:h-auto w-full overflow-hidden group rounded-[100px] shadow-xl">
            <div className="absolute inset-0 bg-primary/10 z-10 group-hover:bg-transparent transition-colors duration-700" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599594/img/kunakia_featured_offering.png" alt="Professional motorhome servicing at Caravan Smash Repairs Sydney" className="w-full h-full object-cover object-center transition-transform duration-1000 group-hover:scale-105" />
          </div>

          {}
          <div className="relative flex flex-col justify-center p-8 lg:p-16 border border-border/60 bg-white/60 backdrop-blur-md shadow-2xl rounded-xl">
            {}
            <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-accent" />
            <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-accent" />
            <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-accent" />
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-accent" />

            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <Badge variant="outline" className="border-secondary text-secondary font-mono uppercase tracking-widest text-[10px] px-3 py-1 rounded-sm">
                  Certified Workshop
                </Badge>
                <Star className="w-4 h-4 text-accent opacity-60 fill-accent" />
              </div>

              <h2 className="text-4xl md:text-5xl lg:text-6xl font-sans font-extrabold text-primary leading-tight tracking-tighter">
                Expert Servicing for Sydney Travellers
              </h2>

              <div className="w-12 h-[2px] bg-accent" />

              <p className="text-muted-foreground text-lg leading-relaxed font-sans font-medium">
                Ensure your caravan or motorhome is road-ready with our comprehensive 
                safety inspections and structural repairs. We prioritize longevity and 
                performance for every Sydney explorer seeking peak reliability.
              </p>

              <ul className="space-y-3 py-4">
                {["Full chassis and brake safety checks", "Electrical and plumbing system audits", "Hail damage and structural restoration"].map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-sm font-sans text-foreground/90">
                    <span className="mt-1.5 w-1.5 h-1.5 bg-secondary rounded-full shrink-0" />
                    {item}
                  </li>)}
              </ul>

              <div className="pt-4">
                <Button asChild className="w-full h-14 text-base font-sans font-bold uppercase tracking-widest bg-accent text-accent-foreground hover:bg-accent/90 rounded-sm transition-all duration-300 shadow-md hover:shadow-lg">
                  <Link to="/StartYourQuotePage">
                    Start Your Quote <ArrowRight className="ml-2 w-4 h-4" />
                  </Link>
                </Button>
                <p className="text-center text-xs font-mono text-muted-foreground mt-4 uppercase tracking-wider">
                  Sydney's trusted repair specialists since 1998.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}